<template>
  <div v-if="!$tools.isWeixinClient() || isPerpetual" :class="{ transparent: transparent }">
    <van-nav-bar
      :title="title"
      left-arrow
      :border="false"
      @click-left="onClickLeft"
      @click-right="onClickRight"
      :fixed="fixed"
    >
      <template #left>
        <div v-if="canHistory || isLeft"></div>
      </template>
      <template #right>
        <slot></slot>
      </template>
    </van-nav-bar>
    <div v-if="fixed" class="placeholder"></div>
  </div>
</template>

<script>
export default {
  name: "TopNav",
  components: {},
  props: {
    title: {
      type: String,
      default: function () {
        return this.$route.meta.title || document.title;
      },
    },
    fixed: {
      type: Boolean,
      default: true,
    },
    isLeft: {
      type: Boolean,
      default: false,
    },
    transparent: {
      type: Boolean,
      default: false,
    },
    backUrl: {
      type: Object,
    },
    isPerpetual: {
      type: Boolean,
    }
  },
  computed: {
    canHistory() {
      if (window.history.length > 1 || this.backUrl) {
        return false;
      } else {
        return true;
      }
    },
  },
  data() {
    return {};
  },
  methods: {
    onClickLeft() {
      if (this.canHistory || this.isLeft) return false;
      console.log(this.backUrl,this.isPerpetual);
      if (this.backUrl) {
        this.$router.push(this.backUrl);
        return;
      }
      if (this.$route.name == "Extend") {
        this.$router.push("/");
        return false;
      }
      this.$router.go(-1);
    },
    onClickRight() {
      this.$emit("clickRight");
    },
  },
  created() {
  },
};
</script>

<style lang="less" scoped>
// .transparent{
//     /deep/ .van-nav-bar{
//         background: transparent;
//     }

// }

/deep/ .van-nav-bar {
  background: #001235;
  width: 768px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 6;

  .van-nav-bar__content {
    height: 2.75rem;
  }

  .van-nav-bar__title {
    color: #e6e9ed;
    font-size: 1.0625rem;
    font-weight: bold;
    line-height: normal;
  }

  .van-nav-bar__arrow {
    font-size: 1.25rem;
    color: #edeff2;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
  }
}

.placeholder {
  height: 2.75rem;
}

nav::-webkit-back-button {
  display: none;
}
nav::before {
  content: "";
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/TopNav.vue